<template>
  <div class="view-settings__sort-by">
    <select
        v-model="select_sort"
        name="sort-by" id="sort-by" class="select-v2 select-v2_medium">
      <!--          <option value="id#asc" :selected="sort == 'id'">Популярные</option>-->
      <option value="price_value-asc">Сначала дешевле
      </option>
      <option value="price_value-desc">Сначала дороже
      </option>
      <option value="name-asc">По алфавиту А-Я</option>
      <option value="name-desc">По алфавиту Я-А</option>
    </select>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "Sort",
  data() {
    return {
      select_sort: 'price_value-asc',
    }
  },
  mounted() {

  },
  computed: {
    ...mapGetters({
      sort_direction: 'group_info/GET_SORT_DIRECTION',
      sort: 'group_info/GET_SORT',
    }),
  },
  beforeMount() {
    let result = window.url_helpers.get_sort()
    if (result !== null) {
      this.select_sort = result
      result = result.split("-")
    }
    this.set_select_sort()
  },
  watch: {
    select_sort() {
      this.set_select_sort()
      window.url_helpers.set_sort(this.select_sort)
    },
  },
  methods: {
    set_select_sort(){
      let result = this.select_sort.split("-")
      this.$store.dispatch("group_info/SET_SORT", {
        "sort": result[0],
        "sort_direction": result[1],
      })

    }
  },
}
</script>

<style scoped>

</style>
